import { gql } from "graphql-request";

const SERVER_DELETE_FAMILY_MEMBER = gql`
  mutation SERVER_DeleteFamilyMember($id: ID!) {
    deleteFamilyMember(id: $id)
  }
`;
export default SERVER_DELETE_FAMILY_MEMBER;
